<template>
	<div class="top-header">
			<div class="container no-padding">
			<span class="adr u-c"><div class="fa fa-map-marker-alt"></div> {{tr.address}}</span>
			</div>
	</div>
</template>

<script>
export default {

  name: 'top-header',

  computed:{
    lang(){return this.$store.state.lang;},
    tr(){return this.$store.getters.translates;}
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.top-header{
	background: #144576;
	padding:7px 2px;
	position: fixed;
	top:0;
	width:100%;
	color:white;
	z-index: 999;
	font-size:12px;
}
.adr{
}
@media(max-width: 700px){
	.top-header{
		/*display: none;*/
		text-align: center;
	}
}

</style>